import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import axios from 'axios';
import Homes from './Pages/Home/Homes';
import Member from './Pages/Members/Member';
import About from './Pages/About/About';
import Directors from './Pages/Directors/Directors';
import ContactUs from './Pages/Contact Us/ContactUs';
import RMBLeaders from './Pages/RMBLeaders/RMBLeaders';
import Meetings from './Pages/Meetings/Meetings';
import RMBJaipur from './Pages/RMBJaipur/RMBJaipur';
import BlogDetails from './Blogs copy/BlogDetails';
import BlogList from './Blogs copy/BlogList';
import { blogs } from './Blogs copy/BlogData';
import Leadership from './Pages/Directors/Leadership';
import Coordinator from './Pages/Directors/Coordinator';
import Login from './Member Login And Register/Login';
import Register from './Member Login And Register/Register';
import ProtectedRoute from './Dashbord/ProtectedRoute';
import Dashboard from './Dashbord/Dashbord';
import MemberPortal from './UserDashbord/MemberPortal';
import Gallery from './Pages/Gallery/Gallery';
import EventRsvpPage from './Pages/Events/EventRsvpPage';

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homes />} />
        <Route path="/home" element={<Homes />} />
        <Route path="/members" element={<Member />} />
        <Route path="/about" element={<About />} />
        <Route path="/directors" element={<Directors />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/coordinators" element={<Coordinator />} />
        <Route path="/contact" element={<ContactUs/>} />
        <Route path="/rmbleaders" element={<RMBLeaders/>} />
        <Route path="/meetings" element={<Meetings/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/register" element={<Register/>} />
        <Route path="/rmbjaipur" element={<RMBJaipur/>} />
        <Route path="/memberportal" element={<MemberPortal/>} />
        <Route path="/user-dashboard" element={<MemberPortal/>} />
        <Route path="/gallery" element={<Gallery/>} />
        <Route path="/event-rsvp/:eventId" element={<EventRsvpPage />} />
        <Route path="/rsvp/:eventId" element={<EventRsvpPage />} />
        <Route path="/blog/:title" element={<BlogDetails />} />
        <Route path="/blogs" element={<BlogList blogs={blogs}/>}/>
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
